import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  CONFIRM_GENERIC_ERROR_BANK,
  CONFIRM_GENERIC_ERROR_VALID_BANK,
  ORIGEN_VALIDAR_API_SANTANDER,
  ORIGEN_VALIDAR_CUENTAS_DIGITALES,
  SELECTED_BANK,
  TYPES_BANKS,
  TYPES_BANKS_ACCOUNTS,
} from "@constants/cambio-via-pago-properties.constants";
import {
  INICIO,
  ROUTING_CAMBIO_VIA_PAGO_PENSION
} from "@constants/url.constant";
import { ISelectedBank } from "@interfaces/seleted-bank.interface";
import { ITiposBancos } from "@interfaces/tipos-bancos.interface";
import { ITiposCuentasBancarias } from "@interfaces/tipos-cuentas-bancarias.interface";
import { ValidarRequest } from "@interfaces/validar-cuentas.interface";
import { ModalOptions } from "@ionic/angular";
import { IonCheckbox, IonChip, IonIcon, IonLabel, IonSkeletonText, IonSpinner, IonText } from "@ionic/angular/standalone";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from "@services/steps/steps.service";
import { StorageService } from "@services/storage/storage.service";
import { Util } from "@shared/common/utils/util";
import { DropdownComponent } from "@shared/components/dropdown";
import { GenericErrorComponent } from "@shared/components/generic-error";
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";
import { ModalValidarCuentasComponent } from "@shared/components/modal-validar-cuentas/modal-validar-cuentas.component";
import { Subscription, combineLatest, firstValueFrom } from "rxjs";
import { CambioViaPagoPensionService } from "../../core/services/cambio-via-pago-pension.service";

@Component({
  selector: "app-cambio-via-pago-datos-bancarios",
  templateUrl: "./cambio-via-pago-datos-bancarios.component.html",
  styleUrls: ["./cambio-via-pago-datos-bancarios.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonSkeletonText,
    IonIcon,
    IonSpinner,
    IonLabel,
    IonCheckbox,
    IonChip,
    IonText,
    DropdownComponent,
    GenericErrorComponent
  ],
  standalone: true,
})
export class CambioViaPagoDatosBancariosComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  isLoading: boolean = false;
  bancos: ITiposBancos[] = [];
  tipoCuentas: ITiposCuentasBancarias[] = [];
  token: string = "";
  label: string = "Selecciona un banco";
  value: string = "";
  isLoadData: boolean = false;

  form: FormGroup;
  cuentaBancaria: any;
  opcionesModal: ModalOptions;
  excepcionServicio: boolean = false;
  bancoSeleccionado: number = 0;
  sub: Subscription = new Subscription();

  isError: boolean = false;
  errorOps: GenericErrorOps;
  attempt: boolean = false;
  nAttempts: number = 0;
  selectedIndex = -1;

  constructor(
    private readonly storageService: StorageService,
    private readonly stepsService: StepsService,
    private readonly _fb: FormBuilder,
    private readonly _cambioViaPagoPensionService: CambioViaPagoPensionService,
    private readonly _modalService: ModalService,
    private readonly _router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly util: Util,
  ) {
    stepsService.setCurrentStep(2);
    this.crearFormulario();
  }

  ngOnInit() {
    void this.initializeComponent();
  }

  private async initializeComponent() {
    this.loading = true;
    this.token = await this.util.getIdToken();

    await this.loadData();
  }
  async loadData() {
    this.sub.add(
      combineLatest([
        this._cambioViaPagoPensionService.obtenerTipoCuentas(this.token),
        this._cambioViaPagoPensionService.obtenerBancos(this.token),
      ]).subscribe({
        next: ([tiposCuentas, tiposBancos]) => {
          this.tipoCuentas = tiposCuentas.filter((x: any) => x.escribe);
          this.tipoCuentas = this.tipoCuentas.map((cuenta) => ({
            ...cuenta,
            seleccionado: true,
          }));
          this.isError = false;
          this.attempt = false;
          this.bancos = tiposBancos;
          this.formatBanks(this.bancos);
          this.storageService.set(TYPES_BANKS, this.bancos);
          this.storageService.set(TYPES_BANKS_ACCOUNTS, this.tipoCuentas);
          this.loading = false;
        },
        error: () => {
          this.isLoadData = true;
          this.errorOps = CONFIRM_GENERIC_ERROR_BANK;
          this.errorImplement();
        },
      }),
    );
  }
  formatBanks(banksArray: ITiposBancos[]) {
    banksArray = this.sortTypessBanks(banksArray);
    for (const bank of banksArray) {
      bank.descripcion = bank.nameBanco.includes("Banco")
        ? bank.nameBanco
        : `Banco ${bank.nameBanco}`;
      bank.visible = true;
    }
  }

  sortTypessBanks(typeBanks: ITiposBancos[]) {
    return typeBanks.sort((a, b) =>
      a.nameBanco.trim().localeCompare(b.nameBanco.trim()),
    );
  }

  private crearFormulario() {
    this.form = this._fb.group({
      codigoInstitucionFinanciera: ["", Validators.required],
      tipoCuenta: ["", Validators.required],
      numeroCuenta: [
        "",
        [
          Validators.required,
          Validators.maxLength(18),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      checkLegal: [false, Validators.required],
      descripcionBanco: [""],
      descripcionTipoCuenta: [""],
    });
  }

  async seleccionBanco(event: any) {
    let val = event.idBanco;
    this.value = event.idBanco;
    this.tipoCuentas = await this.storageService.get(TYPES_BANKS_ACCOUNTS);
    const bancoEstado = 12;
    const tipoCuentaRUT = 34;
    if (val != bancoEstado)
      this.tipoCuentas = this.tipoCuentas.filter(
        (elemento) => elemento.idTipoCuenta !== tipoCuentaRUT,
      );

    this.form.patchValue({
      tipoCuenta: "",
      numeroCuenta: "",
      checkLegal: false,
      descripcionTipoCuenta: "",
      descripcionBanco: event.descripcion,
    });

    if (this.isCuentaRut) await this.getRutAfiliado();
  }

  seleccionarCuenta(id: number) {
    for (const opcion of this.tipoCuentas) {
      opcion.seleccionado = true;
    }

    if (this.tipoCuentas.some((x) => x.idTipoCuenta == id)) {
      const index = this.tipoCuentas.findIndex((x) => x.idTipoCuenta == id);
      this.tipoCuentas[index].seleccionado = false;

      this.form.get("tipoCuenta")?.setValue(id);

      this.form.patchValue({
        numeroCuenta: "",
        checkLegal: false,
        descripcionTipoCuenta: this.tipoCuentas[index].nameTipoCuenta,
      });

      if (this.isCuentaRut) void this.getRutAfiliado();
    }
  }

  onChange(event: any) {
    if (!this.isCheckLegal && this.form.get("checkLegal")?.value)
      this.form.patchValue({ checkLegal: false });
  }

  async getRutAfiliado() {
    try {
      const rut = await this._cambioViaPagoPensionService.uid();
      const cuentaRut = rut.slice(0, -1);
      this.form.get("numeroCuenta")?.setValue(cuentaRut);
    } catch (error) {
      console.error("Error fetching UID:", error);
      const rut = await this._cambioViaPagoPensionService.uid();
      const cuentaRut = rut.slice(0, -1);
      this.form.get("numeroCuenta")?.setValue(cuentaRut);
    }
  }

  enterCheckLegal() {
    const check = this.form.get("checkLegal")?.value;
    if (check) this.form.get("checkLegal")?.setValue(false);
    else this.form.get("checkLegal")?.setValue(true);
  }

  validateInput(event: any) {
    const regex = /^\d*$/;

    if (regex.test(event.key))
      return this.form.get("numeroCuenta")?.value.toString().length !== 18;
    else return false;
  }

  pastePrevent(event: ClipboardEvent) {
    event.preventDefault();
  }

  exit() {
    void this._modalService.cambioViaPagoExitModal();
  }

  async continue() {
    if (this.attempt && this.form.invalid) {
      return;
    }

    this.isLoading = true;

    const {
      codigoInstitucionFinanciera,
      numeroCuenta,
      tipoCuenta,
      descripcionTipoCuenta,
      descripcionBanco,
    } = this.form.value;
    const selectBank = {
      codigoInstitucionFinanciera: String(codigoInstitucionFinanciera),
      numeroCuenta,
      tipoCuenta: String(tipoCuenta),
      descripcionTipoCuenta,
      descripcionBanco,
    } as ISelectedBank;

    try {
      
      const requestValidaCuentas: ValidarRequest = {
        codigoInstitucionFinanciera,
        numeroCuenta,
      };
      const responseValidaCuentas = await firstValueFrom(
        this._cambioViaPagoPensionService.validarCuentasBancarias(
          requestValidaCuentas,
          this.token,
        ),
      );

      if (responseValidaCuentas?.switchHabilitarApiSantander) {
        if (responseValidaCuentas.estadoValidacionAPI === "R") {
          this.excepcionServicio = false;
          await this.abrirModalValidarCuentas(
            ORIGEN_VALIDAR_API_SANTANDER,
            selectBank,
          );
          this.isLoading = false;
          return;
        } else {
          this.storageService.set(SELECTED_BANK, selectBank);
          this._router.navigate(
            [`../${ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_CONFIRMAR}`],
            {
              relativeTo: this.activatedRoute,
            },
          );
          this.isLoading = false;
        }
      } else {
        this.storageService.set(SELECTED_BANK, selectBank);
        this._router.navigate(
          [`../${ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_CONFIRMAR}`],
          {
            relativeTo: this.activatedRoute,
          },
        );
        this.isLoading = false;
      }
    } catch (error) {
      console.error("Error during continue():", error);
      this.isLoadData = false;
      this.errorOps = CONFIRM_GENERIC_ERROR_VALID_BANK;
      this.errorImplement();
    }
  }
  errorImplement() {
    if (this.nAttempts === 3) {
      this.attempt = false;
      this.isError = false;
      this.nAttempts = 0;
      this._router.navigate([
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME,
      ]);
      this.stepsService.setShowStepper(false);
    }
    this.loading = false;
    this.isLoading = false;
    this.isError = true;
    this.attempt = false;
    this.stepsService.setShowStepper(true);
  }

  async abrirModalValidarCuentas(
    origen: string,
    selectBank?: ISelectedBank,
  ): Promise<boolean> {
    const opcionesModal: ModalOptions = {
      component: ModalValidarCuentasComponent,
      backdropDismiss: true,
      cssClass: "validarCuentas__modal",
      componentProps: {
        origenValidacion: origen,
      },
    };

    const modal = await this._modalService.openModal(opcionesModal);
    const { data } = await modal.onDidDismiss();

    if (data === undefined) {
      this.resetForm();
      return false;
    }

    switch (data.origen) {
      case ORIGEN_VALIDAR_CUENTAS_DIGITALES:
        this.resetForm();
        return true;
      case ORIGEN_VALIDAR_API_SANTANDER:
        if (data.botonIngresar) {
          this.storageService.set(SELECTED_BANK, selectBank);
          this._router.navigate(
            [`../${ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_CONFIRMAR}`],
            {
              relativeTo: this.activatedRoute,
            },
          );
        } else {
          this.resetForm();
        }
        return true;
      default:
        return false;
    }
  }
  resetForm() {
    this.form.patchValue({
      codigoInstitucionFinanciera: "",
      tipoCuenta: "",
      numeroCuenta: "",
      checkLegal: false,
    });

    for (const cuenta of this.tipoCuentas) {
      cuenta.seleccionado = true;
    }

    this.value = "";
  }

  async onRetryEvent() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3 && this.isLoadData) {
      await this.loadData();
    } else if (this.nAttempts <= 3 && !this.isLoadData) {
      await this.continue();
    }
  }

  onGoToEvent() {
    this._router.navigate([INICIO]);
    this.stepsService.setShowStepper(true);
  }

  get isInvalidForm(): boolean {
    return this.form.invalid || this.form.getRawValue().checkLegal === false;
  }

  get isCuentaRut(): boolean {
    return (
      this.form.get("codigoInstitucionFinanciera")?.value === 12 &&
      this.form.get("tipoCuenta")?.value === 34
    );
  }

  get isCheckLegal(): boolean {
    return (
      this.form.get("codigoInstitucionFinanciera")?.value !== "" &&
      this.form.get("tipoCuenta")?.value !== "" &&
      this.form.get("numeroCuenta")?.value !== ""
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}